import { createAction, props } from '@ngrx/store';
import { IProfileStatusRequest, IProfileStatusResponse } from '../models/profile-status.model';

export const loadProfileStatus = createAction(
  '[Employee Detail] Load Profile Status',
  props<{ request: IProfileStatusRequest }>()
);

export const loadProfileStatusSuccess = createAction(
  '[Employee Detail] Load Profile Status Success',
  props<{ response: IProfileStatusResponse }>()
);

export const loadProfileStatusFailure = createAction(
  '[Employee Detail] Load Profile Status Failure',
  props<{ error: any }>()
);

export const resetProfileStatus = createAction(
  '[Employee Detail] Reset Profile Status'
);